/**
 * @generated SignedSource<<5d99982ea88d6b596b6f2d8e0a6cd6a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventZoomMeetingFragment$data = {
  readonly id: string;
  readonly hostId: string;
  readonly joinUrl: string;
  readonly password: string;
  readonly startUrl: string;
  readonly status: string;
  readonly timezone: string;
  readonly uuid: string;
  readonly " $fragmentType": "eventZoomMeetingFragment";
};
export type eventZoomMeetingFragment$key = {
  readonly " $data"?: eventZoomMeetingFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventZoomMeetingFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eventZoomMeetingFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hostId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "joinUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "password",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    }
  ],
  "type": "ZoomMeetingDetails",
  "abstractKey": null
};

(node as any).hash = "c4e76aa17dd85cc9e8c4cf3f220496bb";

export default node;
